<div class="layout-container">
  <aside class="sidebar" [class.open]="(layout.sidebarOpen$ | async)">
    <div class="logo-container">
      <img *ngIf="themeService.getCurrentTheme() === 'light'" src="images/logo.png" alt="BarberPass">
      <img *ngIf="themeService.getCurrentTheme() === 'dark'" src="images/logo_dark.png" alt="BarberPass">
    </div>
    
    <a routerLink="/dashboard" routerLinkActive="active" class="nav-item">
      <i class="fas fa-chart-line"></i> Dashboard
    </a>

    <a routerLink="/home" routerLinkActive="active" class="nav-item">
      <i class="fas fa-bullhorn"></i> Meus Anúncios
    </a>
    
    <div class="menu-label">Criar campanha</div>

    <a routerLink="/anuncios/barbearias" routerLinkActive="active" class="nav-item">
      <i class="fas fa-briefcase"></i> Anúncios Barbearias (B2B)
    </a>
    <a routerLink="/anuncios/clientes" routerLinkActive="active" class="nav-item">
      <i class="fas fa-users"></i> Anúncios Usuários (B2C)
    </a>
    <a routerLink="/anuncios/video" routerLinkActive="active" class="nav-item">
      <i class="fas fa-video"></i> Anúncios em Vídeo
    </a>


    <div class="menu-label">Gestão</div>

    <a routerLink="/relatorios" routerLinkActive="active" class="nav-item">
      <i class="fas fa-chart-bar"></i> Relatórios
    </a>
    <a routerLink="/financeiro" routerLinkActive="active" class="nav-item">
      <i class="fas fa-wallet"></i> Financeiro
    </a>
    <a routerLink="/configuracoes" routerLinkActive="active" class="nav-item">
      <i class="fas fa-cog"></i> Configurações
    </a>
  </aside>
  <main class="main-content">
    <app-topbar></app-topbar>
    <div class="content-area">
      <router-outlet></router-outlet>
